import { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

// SVG Icons as components
const IconRocket = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    className="w-12 h-12 text-gray-700"
  >
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
  </svg>
);

const IconTeam = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    className="w-12 h-12 text-gray-700"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const IconChart = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    className="w-12 h-12 text-gray-700"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    <path d="M2 12h20" />
    <text x="16" y="9" fontSize="4" fontWeight="bold">
      %
    </text>
  </svg>
);

const IconGroup = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    className="w-12 h-12 text-gray-700"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    <rect x="3" y="14" width="18" height="2" rx="1" />
  </svg>
);

// Function to render the appropriate icon
const renderIcon = (iconName) => {
  switch (iconName) {
    case "rocket":
      return <IconRocket />;
    case "team":
      return <IconTeam />;
    case "chart":
      return <IconChart />;
    case "group":
      return <IconGroup />;
    default:
      return null;
  }
};

function MissionSection() {
  const { t } = useTranslation();
  const [missionData, setMissionData] = useState({
    mission: { title: "", statement: "" },
    coreValues: { title: "", values: [] },
  });

   

  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/mission`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setMissionData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);


  return (
    <div className="relative w-full min-h-[500px] bg-gradient-to-r from-blue-500 to-blue-600 overflow-hidden">
      {/* Background image overlay - would be replaced with actual image in production */}
      <div
        className="!absolute inset-0 bg-cover bg-center opacity-50"
        style={{
          backgroundImage: "url('/image/mission.jpg')",
          backgroundBlendMode: "overlay",
        }}
      ></div>

      {/* Content container */}
      <div className="relative flex justify-center items-center w-full h-full py-8 px-4 z-20">
        <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full p-8 md:p-12">
          {/* Mission section */}
          <h2 className="text-3xl font-bold text-center text-orange-400 mb-6">
            {t(missionData.mission.title)}
          </h2>

          <p className="text-xl md:text-2xl text-center italic text-gray-700 mb-8">
            "{t(missionData.mission.statement)}"
          </p>

          <div className="w-full max-w-md mx-auto border-t border-gray-200 my-8"></div>

          {/* Core Values section */}
          <h3 className="text-2xl font-bold text-center text-orange-400 mb-10">
            {t(missionData.coreValues.title)}
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 justify-items-center">
            {missionData.coreValues?.values?.map((value, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="mb-4">{renderIcon(value.icon)}</div>
                <span className="text-gray-700 font-medium">
                  {t(value.name)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MissionSection;
